export const DiscordIconSmall = () => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 21.5616C16.799 21.5616 21.5 16.8606 21.5 11.0616C21.5 5.26259 16.799 0.561584 11 0.561584C5.20101 0.561584 0.5 5.26259 0.5 11.0616C0.5 16.8606 5.20101 21.5616 11 21.5616Z"
                fill="#2E2E2E"
                stroke="white"
            />
            <path
                d="M6.83486 6.77797C7.61164 6.41453 8.44221 6.1504 9.31055 6C9.41719 6.19281 9.54178 6.45213 9.62768 6.65843C10.5508 6.51961 11.4653 6.51961 12.3714 6.65843C12.4573 6.45213 12.5847 6.19281 12.6923 6C13.5616 6.1504 14.3931 6.4155 15.1699 6.77989C16.7367 9.14749 17.1614 11.4563 16.949 13.7323C15.9099 14.5083 14.9028 14.9797 13.9127 15.2882C13.6683 14.9518 13.4502 14.5941 13.2624 14.2172C13.6201 14.0813 13.9627 13.9135 14.2865 13.7188C14.2006 13.6552 14.1166 13.5887 14.0354 13.5202C12.0609 14.4437 9.91555 14.4437 7.96463 13.5202C7.88252 13.5887 7.79852 13.6552 7.71358 13.7188C8.03826 13.9145 8.38181 14.0822 8.73952 14.2182C8.5517 14.5941 8.33462 14.9527 8.08922 15.2892C7.09818 14.9807 6.09017 14.5093 5.051 13.7323C4.80182 11.0938 5.47667 8.80623 6.83486 6.77797ZM12.9934 12.3326C13.5861 12.3326 14.0722 11.7792 14.0722 11.1054C14.0722 10.4315 13.5965 9.87724 12.9934 9.87724C12.3903 9.87724 11.9042 10.4306 11.9146 11.1054C11.9137 11.7792 12.3903 12.3326 12.9934 12.3326ZM9.00663 12.3326C9.59936 12.3326 10.0854 11.7792 10.0854 11.1054C10.0854 10.4315 9.60975 9.87724 9.00663 9.87724C8.40352 9.87724 7.91744 10.4306 7.92782 11.1054C7.92782 11.7792 8.40352 12.3326 9.00663 12.3326Z"
                fill="white"
            />
        </svg>
    );
};
